<template>
  <header class="app-header">
    <button class="header-menu-btn" aria-label="Open menu" @click="$emit('toggle-sidebar')">
      <IconMenu :size="20" />
    </button>
    <div class="crumbs">
      <template v-if="breadcrumb && breadcrumb.length">
        <template v-for="(b, i) in breadcrumb" :key="i">
          <span>{{ b }}</span>
          <span class="sep">&rsaquo;</span>
        </template>
      </template>
      <span class="now">{{ title }}</span>
    </div>
    <div class="global-search">
      <IconSearch :size="16" />
      <input placeholder="Search registrations, references, or names..." />
    </div>
    <div class="header-actions">
      <button class="header-icon-btn" aria-label="Notifications" title="Notifications">
        <IconBell :size="18" />
        <span v-if="pendingTour > 0" class="dot" />
      </button>
      <div class="header-avatar-wrap" style="position:relative">
        <button class="header-avatar" aria-label="Account menu" @click="menuOpen = !menuOpen">
          <span class="avatar">{{ initials }}</span>
          <span class="name">{{ currentUser.name }}</span>
          <IconChevron :size="14" />
        </button>
        <div v-if="menuOpen" class="dropdown-menu">
          <div class="dropdown-item dropdown-item--disabled">{{ currentUser.email }}</div>
          <div class="divider" style="margin:4px 0" />
          <button class="dropdown-item dropdown-item--danger" @click="menuOpen = false; $emit('logout')">
            <IconLogOut :size="14" /> Sign out
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { IconSearch, IconBell, IconChevron, IconMenu, IconLogOut } from '@/components/icons'

export default {
  name: 'AppHeader',
  components: { IconSearch, IconBell, IconChevron, IconMenu, IconLogOut },
  props: {
    title: { type: String, default: '' },
    breadcrumb: { type: Array, default: () => [] },
    pendingTour: { type: Number, default: 0 },
    currentUser: { type: Object, default: () => ({ name: 'Admin', email: '' }) }
  },
  emits: ['toggle-sidebar', 'logout'],
  data() {
    return { menuOpen: false }
  },
  computed: {
    initials() {
      return this.currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase()
    }
  },
  mounted() {
    this._closeMenu = (e) => {
      if (!this.$el.querySelector('.header-avatar-wrap')?.contains(e.target)) {
        this.menuOpen = false
      }
    }
    document.addEventListener('click', this._closeMenu)
  },
  beforeUnmount() {
    document.removeEventListener('click', this._closeMenu)
  }
}
</script>
